// extracted by mini-css-extract-plugin
module.exports = {"h5button":"fR","h5Button":"fR","button":"fS","block":"fT","btnDefault":"fU","disable":"fV","btnPrimary":"fW"};